import { Icon, IconProps } from '@chakra-ui/react'

export default function GlassAndLiquidIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#868E96'}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.79407 13.375L9.3314 6.04167C9.3074 5.65767 9.61207 5.33301 9.99674 5.33301H13.6647C14.0494 5.33301 14.3541 5.65767 14.3301 6.04167L13.8674 13.375C13.8454 13.7263 13.5541 13.9997 13.2021 13.9997H10.4594C10.1074 13.9997 9.81607 13.7263 9.79407 13.375Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.72135 3.24267L5.83202 3.02133C5.93135 2.82267 5.93135 2.58867 5.83202 2.39V2.39C5.71202 2.15133 5.46802 2 5.20002 2H3.77868C3.51135 2 3.26668 2.15133 3.14735 2.39V2.39C3.04802 2.58867 3.04802 2.82267 3.14735 3.02133L3.25802 3.24267C3.31335 3.354 3.34268 3.476 3.34268 3.60067V4.25733C3.34268 5.03067 3.08868 5.78333 2.61935 6.398L2.39002 6.69867C1.92002 7.314 1.66602 8.066 1.66602 8.84V12.5887C1.66602 13.368 2.29802 14 3.07802 14H5.90135C6.68135 14 7.31335 13.368 7.31335 12.588V8.84C7.31335 8.06667 7.05935 7.314 6.59002 6.69933L6.36002 6.398C5.89068 5.78267 5.63668 5.03067 5.63668 4.25733V3.60067C5.63668 3.47667 5.66535 3.354 5.72135 3.24267V3.24267Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33789 3.65951H5.63789"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.31188 11.3333H1.67188"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.31188 8.66634H1.67188"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
